export default {
  title: 'Junte-se ao {{name}}!',
  default_program_name: 'Clube de Recompensas',
  savings_highlight: {
    title: 'Seja recompensado. Em cada encomenda, sempre.',
    subtitle: 'Registe-se em segundos e comece a ganhar pontos.',
  },
  how_it_works: {
    label: 'Como funciona',
    step_1: {
      title: 'Registe-se em 30 s',
      desc: 'Apenas o seu número de telemóvel',
    },
    step_2: {
      title: 'Encomende e ganhe',
      desc: '{{percentage}}% de volta em cada encomenda',
    },
    step_3: {
      title: 'Resgate e poupe',
      desc: 'Até {{amount}} de desconto por encomenda',
    },
  },
  profile: {
    verified_title: 'Telemóvel verificado!',
    verified_subtitle: 'Complete o seu perfil para começar a ganhar.',
  },
  form: {
    phone_number: {
      label: 'Número de telemóvel',
      description: 'Enviaremos um código de verificação para confirmar a sua identidade.',
      placeholder: 'Número de telemóvel',
    },
    birthday: {
      label: 'Aniversário — dia e mês são suficientes para receber um presente 🥳',
      placeholder: 'Aniversário (opcional)',
      parts: {
        month: 'Mês',
        day: 'Dia',
      },
    },
  },
  terms:
    'Ao registar-se, concorda com os nossos <TermsLink>termos e condições</TermsLink> e com a nossa <PrivacyPolicyLink>política de privacidade</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continuar',
    verify: 'Verificar',
    complete: 'Concluir registo',
  },
  toasts: {
    login_success: 'A sua sessão foi iniciada com sucesso',
    invalid_code: 'Código inválido. Por favor, tente novamente.',
    failed_to_update_profile: 'Falha ao atualizar o perfil. Por favor, tente novamente.',
  },
};
